import React, { Component } from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import Skills from "../../containers/skills/Skills";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Experience from "../experience/Experience";
import Projects from "../projects/Projects";
import Products from "../products/Products";
import Contact from "../contact/ContactComponent";
import "./HomeComponent.css";

class Home extends Component {
  render() {
    return (
      <div className="single-page-portfolio">
        <Header theme={this.props.theme} />
        <main>
          <section id="home" className="site-scroll-section home-section">
            <Greeting theme={this.props.theme} />
            <Skills theme={this.props.theme} />
          </section>
          <Experience theme={this.props.theme} embedded />
          <Projects theme={this.props.theme} embedded />
          <Products theme={this.props.theme} embedded />
          <Contact theme={this.props.theme} embedded />
        </main>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Home;
